(function() {
  const initSidebarToggles = () => {
    const sidebar = document.querySelector('[data-sidebar]');
    if (!sidebar) return;

    const toggles = sidebar.querySelectorAll('[data-sidebar-toggle]');
    
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        const content = toggle.nextElementSibling;
        if (!content) return;

        const isOpen = toggle.getAttribute('data-open') === 'true';

        if (!isOpen) {
          // Calculate height
          content.style.visibility = 'hidden';
          content.style.height = 'auto';
          const height = content.scrollHeight;
          content.style.height = ''; // Remove inline height
          content.style.visibility = '';
          
          // Set CSS variable and update state
          content.style.setProperty('--open-height', height + 'px');
          toggle.setAttribute('data-open', 'true');
          toggle.setAttribute('aria-expanded', 'true');
          content.setAttribute('data-animation-state', 'open');
        } else {
          // Close
          toggle.setAttribute('data-open', 'false');
          toggle.setAttribute('aria-expanded', 'false');
          content.setAttribute('data-animation-state', 'closed');
        }
      });
    });
  };

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSidebarToggles);
  } else {
    initSidebarToggles();
  }

  // Support Shopify Theme Editor re-loads
  document.addEventListener('shopify:section:load', initSidebarToggles);
})();
